module.exports = __webpack_public_path__ + "img/logo_mwe_minimal.8db34242.png";